// @flow strict

import * as React from 'react';
import { Button, Select2 } from '@ansarada/ace-react';
import OnBoardingLayout from '../OnBoardingLayout';
import type { QuestionOptionType } from '../../types';

type PropsType = {|
  title: string,
  onBack: () => void,
  onNext: () => void,
  value: string,
  onChange: string => void,
  placeholder: string,
  questionOptions: Array<QuestionOptionType>,
  bgMobile: string,
  bgDesktop: string,
|};

const Question3Stage = (props: PropsType) => {
  const { title, onBack, onNext, value, onChange, placeholder, questionOptions } = props;
  const items = questionOptions.map(q => ({ value: q.value, label: q.text }));
  return (
    <OnBoardingLayout
      title={title}
      actionButtons={[
        <Button onClick={onBack} key="back" id="s6-back">
          Back
        </Button>,
        <Button
          onClick={onNext}
          key="next"
          variant="Primary"
          disabled={questionOptions.length > 0 && !value}
          id="s6-next"
        >
          Next
        </Button>,
      ]}
      bgMobile={props.bgMobile}
      bgDesktop={props.bgDesktop}
    >
      <Select2
        size="Medium"
        placeholder={placeholder}
        value={value}
        options={[{ title: '', items }]}
        onChange={option => onChange(option.value)}
        id="s6-stage"
      />
    </OnBoardingLayout>
  );
};

export default Question3Stage;
